import Immutable from 'immutable';

const LOAD = 'statusCodes/LOAD';
const LOAD_FAIL = 'statusCodes/LOAD_FAIL';
const LOAD_CODES_SUCCESS = 'statusCodes/LOAD_CODES_SUCCESS';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  loading: false,
  statusCodes: []
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);
        

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
       
    case LOAD_CODES_SUCCESS:
      return state
        .set('loadErr', null)
        .set('isLoad', true)
        .set('statusCodes', action.res)


    default:
      return state;
  }
};



export const getStatusCodes = (params = '') => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  let user = getState().get('auth').get('user');
  if(!user.UdaDrList.abbr || !user.UdaDrList.userId) {
    dispatch({ type: LOAD_FAIL, error: "Please add Dentist's details" });
  }
  if(params) {
    params = '/'+JSON.stringify(params);
  }
  try {
    let res = await api.get(`udr/ndp/statuscodes/${user.UdaDrList.userId}${params}`);
    dispatch({ type: LOAD_CODES_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  } 
};

export const updateStatusCode = (details) => async (dispatch, getState, api) => {
  let user = getState().get('auth').get('user');
  if(!user.UdaDrList.abbr || !user.UdaDrList.userId) {
    dispatch({ type: LOAD_FAIL, error: "Please add Dentist's details" });
  }
  
  try {
    let res = await api.put(`udr/ndp/updatestatuscode/${user.UdaDrList.userId}`, {data: details});
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};
